import API from "@/services/api";
export default {
  getPosts(cursor = null) {
    return API().get("posts", {
      params: cursor ? { cursor } : {},
    });
  },
  getPostCount() {
    return API().get("postcount");
  },
  addPost(post) {
    return API().post("addPost", {
      post: post,
    });
  },
};
